/**
 * Defines the available sorting options for a list of products.
 */
export enum ProductSorting {
    TOP_PRODUCTS = 'TOP/DESC',
    NEWS = 'NOVEDAD/DESC',
    FAVORITES = "FAVORITO/DESC",
    LOWER_PRICE = 'PRECIO_POR_CAJA/ASC',
    HIGHER_PRICE = 'PRECIO_POR_CAJA/DESC'
}
